var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSearch = function SvgSearch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.0717 5.1967C7.47822 3.79018 9.38588 3 11.375 3C13.3641 3 15.2718 3.79018 16.6783 5.1967C18.0848 6.60322 18.875 8.51088 18.875 10.5C18.875 12.1528 18.3295 13.7493 17.3381 15.0489L21.5821 19.2929C21.9726 19.6834 21.9726 20.3166 21.5821 20.7071C21.1916 21.0976 20.5584 21.0976 20.1679 20.7071L15.9239 16.4631C14.6243 17.4545 13.0278 18 11.375 18C9.38588 18 7.47822 17.2098 6.0717 15.8033C4.66518 14.3968 3.875 12.4891 3.875 10.5C3.875 8.51088 4.66518 6.60322 6.0717 5.1967ZM11.375 5C9.91631 5 8.51736 5.57946 7.48591 6.61091C6.45446 7.64236 5.875 9.04131 5.875 10.5C5.875 11.9587 6.45446 13.3576 7.48591 14.3891C8.51736 15.4205 9.91631 16 11.375 16C12.8337 16 14.2326 15.4205 15.2641 14.3891C16.2955 13.3576 16.875 11.9587 16.875 10.5C16.875 9.04131 16.2955 7.64236 15.2641 6.61091C14.2326 5.57946 12.8337 5 11.375 5Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export default ForwardRef;